import React from 'react'
import GenericBanner from '@/components/GenericBanner'
import { GenericBannerContent } from '@/types'

type BannerContentPropsType = {
  banners?: GenericBannerContent[]
  headingFontColor?: string
  smallHeadingFontColor?: string
}
const BannerContent = ({
  banners,
  headingFontColor,
  smallHeadingFontColor
}: BannerContentPropsType) => {
  return banners ? (
    <>
      {banners.map((banner, index) => (
        <GenericBanner
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          content={banner}
          headingFontColor={headingFontColor || 'text.base'}
          smallHeadingFontColor={smallHeadingFontColor || 'text.light'}
        />
      ))}
    </>
  ) : null
}

export default BannerContent
